import { useCallback } from 'react';
import { matchPath } from 'react-router-dom';
import { find } from 'lodash';
import { useMultiLayerDrawerContext } from '../modules/multi-layer-drawer/components/MultiLayerDrawerProvider/MultiLayerDrawerProvider';
import { useMultiLayerDrawerEnabled } from '../modules/multi-layer-drawer/hooks/useMultiLayerDrawerEnabled';
import { useDrawerStack } from './queryParams/useDrawerStack';
import { useNavigate } from './useNavigate';

const useDrawerNavigate = (pushToDrawer = true) => {
    const { push } = useDrawerStack();
    const isMultiLayerDrawerEnabled = useMultiLayerDrawerEnabled();
    const { forms } = useMultiLayerDrawerContext();

    const navigate = useNavigate();

    const stackPush = useCallback(
        (pattern, queryParams) => {
            const patternTemplate = find(forms, ({ path }) => !!matchPath(pattern, { path, exact: false }))?.path;
            push({ path: pattern, pattern: patternTemplate, queryParams });
        },
        [push, forms]
    );

    return pushToDrawer && isMultiLayerDrawerEnabled ? stackPush : navigate;
};

//TODO: https://tbla.atlassian.net/browse/DEV-181856 replace useNavigate with useDrawerNavigate

export { useDrawerNavigate as useNavigate };
